import { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BoardContext, SocketContext } from '../../../context';
import { PinkNotification } from '../../atoms';
import ChatMolecule from './ChatMolecule';

const BoardChat: FC<{}> = () => {
    const { t } = useTranslation();
    const { chatMessages } = useContext(SocketContext);
    const { instructionTutorial } = useContext(BoardContext);
    const [isChatButtonClicked, setIsChatButtonClicked] = useState<boolean>(false);
    const [isThereUnreadMessage, setIsThereUnreadMessage] = useState<boolean>(false);

    useEffect( () => {
        if(chatMessages && !isChatButtonClicked)
            setIsThereUnreadMessage(true);   
    }, [chatMessages, isChatButtonClicked]);

    useEffect( () => {
        if(!isChatButtonClicked)
            setIsThereUnreadMessage(false);

        if (isChatButtonClicked)
            setIsThereUnreadMessage(false);
    }, [isChatButtonClicked]);

    const toggleChatButton = () => {
        setIsChatButtonClicked(!isChatButtonClicked);
    }

    const showChat = () => {
        if (isChatButtonClicked)
            return (
                <div className="board_chat_wrapper chat_molecule_wrapper_pop_up_animation board_chat_height_opened" >
                    <ChatMolecule shouldTheFirstMessageBeShown={false} />
                </div>
            )
        
            return (
                <div>
                    <div className="board_chat_wrapper board_chat_height_closed" >
                        <ChatMolecule shouldTheFirstMessageBeShown={false} />
                    </div>
                </div>
            )
        
    }

    return (
        <div className="board_chat_wrapper">
            {instructionTutorial === "leftSideOfTheScreen" && 
                <div style={{position: "relative"}}>
                    <PinkNotification notificationWidthVW={30} notificationRenderingSide="right" text={t("callTheFacilitatorText")} moveFromTop={10} progressNumber={7} isTextShort={true} /> 
                </div>
            }
            <div className={`position_chat_button ${isChatButtonClicked ? "close_chat_button_icon" : "chat_button_icon"}`} onClick={toggleChatButton}>
                {isThereUnreadMessage && <div className="green_notification"></div>}
            </div>
            {showChat()}
        </div>
    );
}

export default BoardChat;

